import React, { useState, useEffect } from "react";
import "../../scss/Dashboard.css";
import { Tab, Tabs, TabList } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useDispatch, useSelector } from "react-redux";
import eye from "../../assets/eye_159078.png";

import { ExportToExcelGeneric } from "../../Utils/GenerateExcel";

import { allDataThunk, allData } from "../../redux/allDataSlice";
import { genericReport, hasQuestions} from "../../Utils/reportGenerator";


const foodOrder=(foods) =>{
  if (!Array.isArray(foods)) return [];
  const ideal=[
    "halal", "jain", "kosher", "vegetarian", "vegan", "pescatarian", "fasting", "no beef", "no chicken", "no dairy", "no fish", "no onion", "no pork", "no onion no garlic", "coeliac", "gluten free"
  ];
  const result=foods.map(v=>v);
  result.sort((a,b) => {
    const aval=a?.food_name?.toLowerCase();
    const bval=b?.food_name?.toLowerCase();
    const apos=ideal.reduce((prev,v,i) => 
      (prev<1000) ? prev : (aval.startsWith(v)) ? i : prev
    ,1000);
    const bpos=ideal.reduce((prev,v,i) => 
      (prev<1000) ? prev : (bval.startsWith(v)) ? i : prev
    ,1000);
    return apos-bpos;
  });
  return result;
}

const drinkOrder=(foods) =>{
  if (!Array.isArray(foods)) return [];
  const ideal=[
    "soft drinks", "beer", "red wine", "white wine", "rose wine", "champagne", "prosecco", "brandy", "gin", "rum", "tequila", "vodka", "wiskey"
  ];
  const result=foods.map(v=>v);
  result.sort((a,b) => {
    const aval=a?.drink_name?.toLowerCase();
    const bval=b?.drink_name?.toLowerCase();
    const apos=ideal.reduce((prev,v,i) => 
      (prev<1000) ? prev : (aval.startsWith(v)) ? i : prev
    ,1000);
    const bpos=ideal.reduce((prev,v,i) => 
      (prev<1000) ? prev : (bval.startsWith(v)) ? i : prev
    ,1000);
    return apos-bpos;
  });
  return result;
}

const FoodAndDrinkSubReport = () => {
  const dispatch = useDispatch();
  const [guestList, setGuestList] = useState([]);
  const [reportName, setReportName] = useState("All");
  const [guestListLoading, setGuestListLoading] = useState(true);
  const [foodDrinkFilter, setFoodDrinkFilter] = useState("");
  const [ceremonyFilter, setCeremonyFilter] = useState("");
  const [hasDrinks, setHasDrinks] = useState(false);
  const allDataLoaded = useSelector((state) => state.allData.loaded);
  const allDataChanged = useSelector((state) => state.allData.changed);

  const exportData = () => {
    const data = [["Name", "Guest of", "Email", "Mobile", "Group", "Food", "Allergies"]];
    if (hasDrinks) {
      data[0].push("Drink 1", "Drink 2");
    }
    for (const guest of guestList) {
      const dat = [
        guest?.guest_name,
        guest?.parentGuest?.guest_name,
        guest?.email,
        guest?.mobile_number,
        guest?.group_name,
        asArray(guest?.food).join(", "),
        guest?.allergy_combined,
      ];
      if (hasDrinks) {
        dat.push(guest?.drink1, guest?.drink2)
      }
      data.push(dat);
    }
    return data;
  }

  const asArray = (a) => {
    if (Array.isArray(a)) return a;
    if (a===undefined || a===null) return [];
    return [a];
  }

  const getReport=() => {
    const hasDrink = hasQuestions(allData, ["drink1"]);
    setHasDrinks(hasDrink);
    var result = genericReport(allData, ["allergy", "food", "drink1", "drink2"]);
    for (const rec of result) {
      const newArray = asArray(rec.allergy).concat(asArray(rec.allergy_details)).filter(v=>v!="");
      rec.allergy_combined = newArray.join(", ");
    }
    var reportSuffix = " food";
    if (hasDrink) reportSuffix += " and drink"
    if (foodDrinkFilter!=="") {
      result = result.filter(r=>
            r?.food?.indexOf(foodDrinkFilter) >= 0 || 
            r?.drink1 === foodDrinkFilter || 
            r?.drink2 === foodDrinkFilter
      );
      reportSuffix = " " + foodDrinkFilter;
    }
    if (ceremonyFilter!="") {
      result = result.filter(d=>d.attendance.indexOf(ceremonyFilter)>=0);
      setReportName(ceremonyFilter + " " + reportSuffix);
    } else {
      setReportName("All " + reportSuffix);
    }
    return result;
  }

  useEffect(() => {
    dispatch(allDataThunk());
  }, []);

  useEffect(()=>{
    if (!allDataLoaded) {
      return;
    }

    const result = getReport();
    console.log("report", result);
    setGuestList(result);
    setGuestListLoading(false);
  }, [allDataChanged, foodDrinkFilter, ceremonyFilter]);

  return (
    <div>
      <div className="row gust-box my-4">
        <div className="col-12 tabs-home">
          <div>
            <Tabs>
              <TabList>
                <Tab>
                  <div className="" onClick={() => setCeremonyFilter("")} >
                    <span>All ceremonies</span>
                  </div>
                </Tab>

                {allData?.ceremonies?.map((item) => (
                  <Tab key={item.ceremony_name}>
                    <div className="" onClick={() => setCeremonyFilter(item.ceremony_name)} >
                      <span>{item.ceremony_name}</span>
                    </div>
                  </Tab>
                ))}
              </TabList>
            </Tabs>

            <Tabs>
            <div class="gray-box menu-tabing clearfix">
              <TabList>
                <div id="menu">
                  <Tab>
                    <div className="position-relative" onClick={() => setFoodDrinkFilter("") } >
                      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=" />
                      <span>All</span>
                    </div>
                  </Tab>
                  
                  {foodOrder(allData?.selected_foods)?.map((food) => (
                    <Tab key={food.id}>
                      <div className="position-relative" onClick={() => setFoodDrinkFilter(food.food_name) } >
                        <img src={food.food_icon} alt="" />
                        <span>{food.food_name}</span>
                      </div>
                    </Tab>
                  ))}

                  {drinkOrder(allData?.selected_drinks)?.map((drink) => (
                    <Tab key={drink.id}>
                      <div className="position-relative" onClick={() => setFoodDrinkFilter(drink.drink_name) } >
                        <img src={drink.drink_icon} alt="" />
                        <span>{drink.drink_name}</span>
                      </div>
                    </Tab>
                  ))}
                </div>
              </TabList>
            </div>
              <div className="gray-box mt-3 menu-tabing clearfix">
                <div className="gray-box-inv clearfix">
                    {reportName}
                  <div className="sky-circle d-inline-block">
                    {guestList?.length}
                  </div>
                  <ExportToExcelGeneric dataFn={exportData} fileName={reportName} />
                </div>

                <TabList>
                  {guestListLoading ? (
                    <h5>Loading...</h5>
                  ) : guestList?.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Guest of</th>
                            <th>Email</th>
                            <th>Mobile Number</th>
                            <th>Group</th>
                            <th>Food</th>
                            <th>Allergies</th>
                            {hasDrinks && <th>Drink 1</th>}
                            {hasDrinks && <th>Drink 2</th>}
                            <th>RSVP</th>
                          </tr>
                        </thead>
                        <tbody>
                          {guestList?.map((guest, index) => {
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{guest?.guest_name}</td>
                                <td>{guest?.parentGuest?.guest_name}</td>
                                <td>{guest?.email}</td>
                                <td>{guest?.mobile_number}</td>
                                <td>{guest?.group_name}</td>
                                <td>{asArray(guest?.food).join(", ")}</td>
                                <td>{guest?.allergy_combined}</td>
                                {hasDrinks && <td>{guest?.drink1}</td>}
                                {hasDrinks && <td>{guest?.drink2}</td>}

                                <td className="text-center">
                                  {(guest?.rsvp_code || guest?.parentGuest?.rsvp_code) && 
                                    <a href={"/rsvp/code/"+(guest.rsvp_code || guest?.parentGuest?.rsvp_code)} target="_blank">
                                      <img
                                        className="action-icon"
                                        width={20}
                                        src={eye}
                                        alt={"rsvp for " + guest?.guest_name}
                                      />
                                    </a>
                                  }
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <h4 className="not-found">No Data Found</h4>
                  )}
                </TabList>
              </div>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FoodAndDrinkSubReport;

export {
  drinkOrder,
  foodOrder,
};
